export const mockMainGroup = {
  groupId: 1,
  name: 'root',
  game: false,
  created: '2024-01-01 00:00:00',
  description: '',
  tzOffset: 180,
  currency: 'RUB',
  casinoId: null,
  lavishLevel: 'norm',
  demo: {
    enabled: true,
    balance: false,
    lavishLevel: 'norm'
  },
  moveByPromocode: false
};

export const mockChildrenGroup = [
  {
    groupId: 6,
    name: 'AnonymousGroup',
    game: false,
    created: '2024-03-22 10:08:30',
    description: 'Группа анонимных игроков',
    tzOffset: 0,
    currency: 'RUB',
    casinoId: 2,
    gamerCount: { total: 437, online: 0 },
    lavishLevel: 'low',
    demo: {
      enabled: true,
      balance: true,
      lavishLevel: 'high'
    },
    moveByPromocode: false
  },
  {
    groupId: 8,
    name: 'BabloSlot.com',
    game: false,
    created: '2024-06-27 10:52:37',
    gamerCount: { total: 437, online: 0 },
    description: '',
    tzOffset: 180,
    currency: 'RUB',
    casinoId: 6,
    lavishLevel: 'low',
    demo: {
      enabled: true,
      balance: true,
      lavishLevel: 'high'
    },
    moveByPromocode: false
  },
  {
    groupId: 10,
    name: 'SlotoHub',
    game: false,
    created: '2024-06-27 11:30:04',
    description: '',
    tzOffset: 180,
    currency: 'RUB',
    casinoId: 7,
    lavishLevel: 'low',
    demo: {
      enabled: true,
      balance: true,
      lavishLevel: 'high'
    },
    moveByPromocode: false
  },
  {
    groupId: 13,
    name: 'TestGroup1',
    game: false,
    created: '2024-10-22 11:24:49',
    description: '',
    tzOffset: 0,
    currency: 'RUB',
    casinoId: null,
    lavishLevel: 'low',
    demo: {
      enabled: true,
      balance: true,
      lavishLevel: 'high'
    },
    moveByPromocode: false
  },
  {
    groupId: 2,
    name: 'Vulpin',
    game: false,
    created: '2024-01-19 11:08:46',
    description: '',
    tzOffset: 180,
    currency: 'RUB',
    casinoId: 1,
    lavishLevel: 'low',
    demo: {
      enabled: true,
      balance: true,
      lavishLevel: 'high'
    },
    moveByPromocode: false
  }
];

export const mockChildrenGroup10 = [
  {
    groupId: 11,
    name: 'SlotoHub',
    game: true,
    created: '2024-06-27 11:30:04',
    description: '',
    tzOffset: 180,
    currency: 'RUB',
    casinoId: 7,
    lavishLevel: 'low',
    demo: { enabled: true, balance: true, lavishLevel: 'high' },
    moveByPromocode: false
  },
  {
    groupId: 12,
    name: 'SlotoHub_2',
    game: true,
    created: '2024-06-28 07:29:26',
    description: '',
    tzOffset: 180,
    currency: 'RUB',
    casinoId: 7,
    lavishLevel: 'low',
    demo: { enabled: true, balance: true, lavishLevel: 'high' },
    moveByPromocode: false
  }
];

export const mockChildrenGroup6 = [
  {
    groupId: 30,
    name: 'AnonymousGamers',
    game: true,
    created: '2025-05-22 11:01:57',
    description: '',
    tzOffset: 0,
    currency: 'RUB',
    casinoId: null,
    gamerCount: { total: 437, online: 0 },
    lavishLevel: 'low',
    demo: { enabled: true, balance: true, lavishLevel: 'high' },
    moveByPromocode: false
  },
  {
    groupId: 31,
    name: 'AnonymousSubgroup_1',
    game: false,
    created: '2025-05-22 12:46:58',
    description: '',
    tzOffset: 0,
    currency: 'RUB',
    casinoId: null,
    lavishLevel: 'low',
    demo: { enabled: true, balance: true, lavishLevel: 'high' },
    moveByPromocode: false
  },
  {
    groupId: 40,
    name: 'AnonymousSubgroup_2',
    game: false,
    created: '2025-05-22 13:38:41',
    description: 'Описание группы',
    tzOffset: 180,
    currency: 'RUB',
    casinoId: null,
    lavishLevel: 'low',
    demo: { enabled: false, balance: false, lavishLevel: 'norm' },
    moveByPromocode: false
  }
];

export const mockChildrenGroup31 = [
  {
    groupId: 32,
    name: 'AnonymousSubgroup_1',
    game: true,
    created: '2025-05-22 12:46:58',
    description: '',
    tzOffset: 0,
    currency: 'RUB',
    casinoId: null,
    lavishLevel: 'low',
    demo: { enabled: true, balance: true, lavishLevel: 'high' },
    moveByPromocode: false
  }
];

export const mockGroupData13 = {
  name: 'GamerTestGroup1',
  game: true,
  created: '2024-10-22 11:25:19',
  description: '',
  tzOffset: 0,
  currency: 'RUB',
  casinoId: 14,
  lavishLevel: 'low',
  demo: { enabled: true, balance: true, lavishLevel: 'high' },
  moveByPromocode: false
};

export const mockBonuses = {
  welcome: {
    id: 187,
    enabled: true,
    created: '2025-05-20 08:03:21',
    expireDays: 15,
    userActivate: true,
    packets: [
      {
        prevPlayedOut: true,
        values: {
          EUR: [
            {
              minDeposit: 1,
              maxDeposit: 1,
              percent: 1,
              wager: 1,
              cashout: 1,
              toDeposit: true
            }
          ],
          RUB: [
            {
              minDeposit: 1,
              maxDeposit: 1,
              percent: 1,
              wager: 1,
              cashout: 1,
              toDeposit: true
            }
          ]
        }
      }
    ]
  },
  cashback: {
    id: 135,
    enabled: true,
    created: '2025-01-06 10:53:03',
    timeZone: 2,
    userActivate: true,
    packets: []
  },
  startBot: {
    id: 171,
    enabled: false,
    created: '2025-04-01 07:27:36',
    toDeposit: false,
    values: {
      ARS: {
        amount: 5000,
        wager: 100,
        cashout: 3
      },
      AZN: {
        amount: 5,
        wager: 100,
        cashout: 3
      },
      BRL: {
        amount: 30,
        wager: 100,
        cashout: 3
      },
      EUR: {
        amount: 5,
        wager: 100,
        cashout: 3
      },
      KGS: {
        amount: 500,
        wager: 100,
        cashout: 3
      },
      KZT: {
        amount: 2500,
        wager: 100,
        cashout: 3
      },
      RUB: {
        amount: 501,
        wager: 100,
        cashout: 3
      },
      USDT: {
        amount: 5,
        wager: 100,
        cashout: 3
      },
      UZS: {
        amount: 68000,
        wager: 100,
        cashout: 3
      }
    },
    langs: {
      en: {
        botImage: 'https://devf.securebet.xyz/images/bonus/171-bot-Vaz43cIbBz.jpeg',
        botText: 'Congratulations!\nYou received a bonus for <b>first launch</b> of the bot!',
        desktopImage: 'https://devf.securebet.xyz/images/bonus/171-desktop-DnYsO5skok.png',
        mobileImage: ''
      },
      ru: {
        botImage: 'https://devf.securebet.xyz/images/bonus/171-bot-pasFeFmfj5.png',
        botText: 'Поздравляем!\nВы получили бонус <b>за первый запуск</b> бота!',
        desktopImage: 'https://devf.securebet.xyz/images/bonus/171-desktop-hAdTo4hmg0.png',
        mobileImage: ''
      }
    }
  },
  freespin: [
    {
      id: 287,
      enabled: true,
      created: '2025-08-11 10:30:49',
      name: 'тест',
      currency: 'KZT',
      activated: null,
      expired: null,
      status: 'deleted',
      activatedCount: 0,
      usedCount: 0,
      updateLocked: false,
      campaigns: [
        {
          stepNo: 0,
          minDeposit: 4,
          maxDeposit: 40,
          campaignId: 11
        }
      ]
    },
    {
      id: 290,
      enabled: false,
      created: '2025-08-11 12:08:07',
      name: 'test2',
      currency: 'EUR',
      activated: '2025-08-11 00:00:00',
      expired: '2025-08-19 23:59:59',
      status: 'deleted',
      activatedCount: 0,
      usedCount: 0,
      updateLocked: false,
      campaigns: [
        { stepNo: 0, minDeposit: 5, maxDeposit: 12, campaignId: 11 },
        { stepNo: 1, minDeposit: 7, maxDeposit: 77, campaignId: 11 }
      ]
    },
    {
      id: 291,
      enabled: false,
      created: '2025-08-11 13:42:53',
      name: 'test3',
      currency: 'RUB',
      activated: '2025-08-11 00:00:00',
      expired: '2025-08-18 23:59:59',
      status: 'active',
      activatedCount: 0,
      usedCount: 0,
      updateLocked: false,
      campaigns: [{ stepNo: 0, minDeposit: 4, maxDeposit: 54, campaignId: 2 }]
    }
  ],
  botPhone: []
};

export const mockCurrencies = {
  RUB: { symbol: '₽', useDecimal: true, decimal: 2, type: 'fiat' },
  EUR: { symbol: '€', useDecimal: true, decimal: 2, type: 'fiat' },
  KZT: { symbol: '₸', useDecimal: false, decimal: 0, type: 'fiat' },
  KGS: { symbol: '⃀', useDecimal: false, decimal: 0, type: 'fiat' },
  UZS: { symbol: 'Soʻm', useDecimal: false, decimal: 0, type: 'fiat' },
  AZN: { symbol: '₼', useDecimal: true, decimal: 2, type: 'fiat' },
  ARS: { symbol: '$', useDecimal: true, decimal: 2, type: 'fiat' },
  BRL: { symbol: 'R$', useDecimal: true, decimal: 2, type: 'fiat' },
  USDT: { symbol: '₮', useDecimal: true, decimal: 2, type: 'crypto' }
};

export const mockCasinoList = [
  { id: 1, botName: '', casinoName: 'Vulpin Dev', domain: 'dev.vulpin.com' },
  { id: 6, botName: 'TestFiatBot', casinoName: 'Grand Arena', domain: 'dev.babloslot.net' }
];

export const mockCampaignHash = {
  10: [
    {
      campaignId: 8,
      name: 'test4',
      currency: 'RUB',
      deleted: false,
      games: [
        {
          gameId: 266,
          image: 'https://stage.gamesstatic.com/games/23ca989db9ca5ad94dbca17fa54a123f3f7efc9d.jpg',
          freespinId: 'fb2edutm-00000008-00000266',
          name: 'African Simba',
          bet: { betId: 4, totalBet: 12.5, lines: 0 },
          freespins: 15,
          wager: 4,
          cashout: 4
        }
      ]
    },
    {
      campaignId: 2,
      name: 'test1',
      currency: 'EUR',
      editable: true,
      deleted: false,
      games: [
        {
          gameId: 56,
          freespinId: 'c2rqn9w7-00000002-00000056',
          name: 'Book Of Ra',
          image: `https://img1.akspic.ru/previews/1/6/0/6/7/176061/176061-yablochnyj_pejzazh-yabloko-illustracia-prirodnyj_landshaft-purpur-x750.jpg`,
          bet: { betId: 0, totalBet: 4.5, lines: 0 },
          freespins: 12,
          wager: 12,
          cashout: 44
        }
      ]
    }
  ]
};

export const mockSliderBanner = [
  {
    id: 192,
    enabled: true,
    name: '',
    position: 1,
    language: 'es',
    gameId: 0,
    gameInfo: null,
    makeBotLink: false,
    bannerText: '',
    relativeUrl: '',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/pixelup_1764787036613.jpg',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/pixelup_1764787065040.jpg',
    dateFrom: '2025-12-02 01:38:00',
    dateTo: '2027-05-14 01:38:00',
    weekDays: [true, true, true, true, true, true, true]
  },
  {
    id: 152,
    enabled: true,
    name: '',
    position: 1,
    language: 'ru',
    gameId: 0,
    gameInfo: null,
    makeBotLink: false,
    bannerText: '',
    relativeUrl: '',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/03.mp4',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/01_1.mp4',
    dateFrom: '2025-10-01 06:48:00',
    dateTo: '2027-06-19 06:48:00',
    weekDays: [true, true, true, true, true, true, true]
  },
  {
    id: 189,
    enabled: true,
    name: '',
    position: 2,
    language: 'es',
    gameId: 0,
    gameInfo: null,
    makeBotLink: false,
    bannerText: '',
    relativeUrl: '',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/Без названия (1700 x 400 пикс.).mp4',
    mobileFileUrl:
      'https://f.securebet.xyz/images/banners/Без названия (1700 x 400 пикс.) (720 x 480 пикс.).mp4',
    dateFrom: '2025-12-02 09:10:00',
    dateTo: '2027-01-10 09:10:00',
    weekDays: [true, true, true, true, true, true, true]
  },
  {
    id: 122,
    enabled: true,
    name: '',
    position: 2,
    language: 'ru',
    gameId: 0,
    gameInfo: null,
    makeBotLink: false,
    bannerText:
      '<p>Четверг</p><p>Депозит&nbsp;от&nbsp;300&nbsp;руб.Бонус:&nbsp;50%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p><p>Депозит&nbsp;от&nbsp;1000&nbsp;руб.Бонус:&nbsp;100%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p><p>Депозит&nbsp;от&nbsp;2000&nbsp;руб.Бонус:&nbsp;150%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p><p>Депозит&nbsp;от&nbsp;5000&nbsp;руб.Бонус:&nbsp;200%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p><p>Депозит&nbsp;от&nbsp;11000&nbsp;руб.Бонус:&nbsp;250%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p>',
    relativeUrl: '/banner/banner_bonus',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/qmkquxhij5a8.mp4',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/78rab9r02lh9.mp4',
    dateFrom: '2025-05-01 10:00:00',
    dateTo: '2027-06-26 10:00:00',
    weekDays: [false, false, false, true, false, false, false]
  },
  {
    id: 153,
    enabled: true,
    name: '',
    position: 2,
    language: 'ru',
    gameId: 0,
    gameInfo: null,
    makeBotLink: false,
    bannerText:
      '<p>Пятница</p><p>Депозит&nbsp;от&nbsp;300&nbsp;руб.Бонус:&nbsp;50%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p><p>Депозит&nbsp;от&nbsp;1000&nbsp;руб.Бонус:&nbsp;100%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p><p>Депозит&nbsp;от&nbsp;2000&nbsp;руб.Бонус:&nbsp;150%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p><p>Депозит&nbsp;от&nbsp;5000&nbsp;руб.Бонус:&nbsp;200%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p><p>Депозит&nbsp;от&nbsp;20000&nbsp;руб.Бонус:&nbsp;250%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p><p>Депозит&nbsp;от&nbsp;100000&nbsp;руб.Бонус:&nbsp;300%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</p>',
    relativeUrl: '/banner/banner_bonus',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/k9hfz5hu2jem.mp4',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/lzq6ifiy1xn2.mp4',
    dateFrom: '2025-10-09 10:58:00',
    dateTo: '2027-09-11 10:58:00',
    weekDays: [false, false, false, false, true, false, false]
  },
  {
    id: 154,
    enabled: true,
    name: '',
    position: 2,
    language: 'ru',
    gameId: 0,
    gameInfo: null,
    makeBotLink: false,
    bannerText:
      '<p><strong>Понедельник</strong></p><p><strong>Депозит&nbsp;от&nbsp;300&nbsp;руб.Бонус:&nbsp;100%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;2000&nbsp;руб.Бонус:&nbsp;150%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;3000&nbsp;руб.Бонус:&nbsp;200%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;15000&nbsp;руб.Бонус:&nbsp;250%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p>',
    relativeUrl: '/banner/banner_bonus',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/ns8xw3f5jqd8.mp4',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/zxmozkrbibgh.mp4',
    dateFrom: '2025-10-01 11:14:00',
    dateTo: '2027-08-08 11:14:00',
    weekDays: [true, false, false, false, false, false, false]
  },
  {
    id: 155,
    enabled: true,
    name: '',
    position: 2,
    language: 'ru',
    gameId: 0,
    gameInfo: null,
    makeBotLink: false,
    bannerText:
      '<p><strong>Вторник</strong></p><p><strong>Депозит&nbsp;от&nbsp;300&nbsp;руб.</strong></p><p><strong>Бонус:&nbsp;50%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;2000&nbsp;руб.Бонус:&nbsp;100%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;3000&nbsp;руб.Бонус:&nbsp;150%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;5000&nbsp;руб.Бонус:&nbsp;200%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p>',
    relativeUrl: '/banner/banner_bonus',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/gc23wjyzhulg.mp4',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/njl3zld541v7.mp4',
    dateFrom: '2025-10-01 03:16:00',
    dateTo: '2027-11-20 03:16:00',
    weekDays: [false, true, false, false, false, false, false]
  },
  {
    id: 156,
    enabled: true,
    name: '',
    position: 2,
    language: 'ru',
    gameId: 0,
    gameInfo: null,
    makeBotLink: false,
    bannerText:
      '<p><strong>Среда</strong></p><p><strong>Депозит&nbsp;от&nbsp;300&nbsp;руб.&nbsp;Бонус:&nbsp;100%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;1000&nbsp;руб.Бонус:&nbsp;150%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;3000&nbsp;руб.Бонус:&nbsp;200%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p>',
    relativeUrl: '/banner/banner_bonus',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/44dpwvsuwtod.mp4',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/nf2mec5q4h3b.mp4',
    dateFrom: '2025-10-01 11:17:00',
    dateTo: '2027-10-23 11:17:00',
    weekDays: [false, false, true, false, false, false, false]
  },
  {
    id: 157,
    enabled: true,
    name: '',
    position: 2,
    language: 'ru',
    gameId: 0,
    gameInfo: null,
    makeBotLink: false,
    bannerText:
      '<p><strong>Суббота</strong></p><p><strong>Депозит&nbsp;от&nbsp;300&nbsp;руб.&nbsp;Бонус:&nbsp;50%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;1000&nbsp;руб.Бонус:&nbsp;100%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;3000&nbsp;руб.Бонус:&nbsp;150%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;5000&nbsp;руб.Бонус:&nbsp;200%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p><p><strong>Депозит&nbsp;от&nbsp;15000&nbsp;руб.Бонус:&nbsp;250%&nbsp;(вэйджер&nbsp;х40,&nbsp;кешаут&nbsp;х3)</strong></p>',
    relativeUrl: '/banner/banner_bonus',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/d7gympsjeto7.mp4',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/6sy7cao1wu7p.mp4',
    dateFrom: '2025-09-11 11:19:00',
    dateTo: '2028-03-17 11:19:00',
    weekDays: [false, false, false, false, false, true, false]
  },
  {
    id: 195,
    enabled: true,
    name: '🔥 VULPIN CASINO-da güclü bonusla start ver!',
    position: 1,
    language: 'az',
    gameType: 0,
    gameId: 0,
    makeBotLink: false,
    bannerText:
      '<p>🔥&nbsp;VULPIN&nbsp;CASINO-da&nbsp;güclü&nbsp;bonusla&nbsp;start&nbsp;ver!</p><p>🎁&nbsp;Yeni&nbsp;bonus&nbsp;sistemi&nbsp;—&nbsp;ilk&nbsp;depozitə&nbsp;400%-dək&nbsp;bonus!</p><p></p><p>Nə&nbsp;qədər&nbsp;çox&nbsp;yatırırsansa&nbsp;—&nbsp;startın&nbsp;bir&nbsp;o&nbsp;qədər&nbsp;güclü&nbsp;olur&nbsp;💪</p><p></p><p>💰&nbsp;Bonus&nbsp;pilləkəni:</p><p></p><p>1100&nbsp;AZN&nbsp;—&nbsp;🔥&nbsp;400%</p><p>880&nbsp;AZN&nbsp;—&nbsp;350%</p><p>660&nbsp;AZN&nbsp;—&nbsp;300%</p><p>440&nbsp;AZN&nbsp;—&nbsp;250%</p><p>220&nbsp;AZN&nbsp;—&nbsp;200%</p><p>110&nbsp;AZN&nbsp;—&nbsp;150%</p><p>20&nbsp;AZN&nbsp;—&nbsp;100%</p><p>5&nbsp;AZN&nbsp;—&nbsp;50%</p><p></p><p>🦊&nbsp;Promokod&nbsp;yoxdur,&nbsp;çətinlik&nbsp;yoxdur&nbsp;—&nbsp;sadəcə&nbsp;ilk&nbsp;depozitini&nbsp;et&nbsp;və&nbsp;bonus&nbsp;avtomatik&nbsp;aktivləşsin!</p><p>100%-dən&nbsp;yuxarı&nbsp;bonuslar&nbsp;üçün&nbsp;veycer&nbsp;x40,</p><p>50%&nbsp;və&nbsp;100%&nbsp;bonuslar&nbsp;üçün&nbsp;veycer&nbsp;x5.</p><p>Bonus&nbsp;qeydiyyatdan&nbsp;sonra&nbsp;14&nbsp;gün&nbsp;aktivdir.</p><p>Digər&nbsp;hallarda&nbsp;bonus&nbsp;mövcud&nbsp;olmayacaq.</p><p></p><p>🚀&nbsp;Yeni&nbsp;oyunçular&nbsp;üçün&nbsp;ideal&nbsp;start!</p><p>4&nbsp;dəfə&nbsp;çox&nbsp;almaq&nbsp;istəyirsən?&nbsp;İndi&nbsp;hərəkətə&nbsp;keç!&nbsp;💸🔥</p>',
    relativeUrl: '',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/v24hwzirz0db.jpg',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/kunr55vtwa96.jpg',
    dateFrom: '2026-03-10 00:00:00',
    dateTo: '2035-03-17 23:59:00',
    weekDays: [true, true, true, true, true, true, true]
  },
  {
    id: 198,
    enabled: true,
    name: '🎉 Bonuslar davam edir!',
    position: 2,
    language: 'az',
    gameType: 0,
    gameId: 0,
    makeBotLink: false,
    bannerText:
      '<p>🎉&nbsp;Bonuslar&nbsp;davam&nbsp;edir!</p><p>🔥&nbsp;2-ci&nbsp;depzitdən&nbsp;5-ci&nbsp;depozitədək&nbsp;—&nbsp;səxavətli&nbsp;mükafatlar&nbsp;al&nbsp;və&nbsp;udmaq&nbsp;şansını&nbsp;ikiqat&nbsp;artır!</p><p></p><p>💸&nbsp;2-ci&nbsp;depozit:</p><p></p><p>66&nbsp;AZN&nbsp;→&nbsp;🎁&nbsp;150%&nbsp;bonus</p><p>44&nbsp;AZN&nbsp;→&nbsp;120%&nbsp;bonus</p><p>22&nbsp;AZN&nbsp;→&nbsp;100%&nbsp;bonus</p><p></p><p>💸&nbsp;3-cü&nbsp;depozit:</p><p></p><p>66&nbsp;AZN&nbsp;→&nbsp;🎁&nbsp;120%&nbsp;bonus</p><p>44&nbsp;AZN&nbsp;→&nbsp;100%&nbsp;bonus</p><p>22&nbsp;AZN&nbsp;→&nbsp;80%&nbsp;bonus</p><p></p><p>💸&nbsp;4-cü&nbsp;depozit:</p><p></p><p>33&nbsp;AZN&nbsp;→&nbsp;🎁&nbsp;100%&nbsp;bonus</p><p></p><p>💸&nbsp;5-ci&nbsp;depozit:</p><p></p><p>22&nbsp;AZN&nbsp;→&nbsp;🎯&nbsp;50%&nbsp;sabit&nbsp;bonus</p><p></p><p>🦊&nbsp;Promokod&nbsp;yoxdur.&nbsp;Artıq&nbsp;şərt&nbsp;yoxdur.</p><p>Sadəcə&nbsp;sən,&nbsp;depozit&nbsp;—&nbsp;və&nbsp;bonus!</p><p>Bütün&nbsp;bonuslar&nbsp;üçün&nbsp;veycer&nbsp;x40.</p><p>Bonus&nbsp;qeydiyyatdan&nbsp;sonra&nbsp;14&nbsp;gün&nbsp;aktivdir.</p><p>Digər&nbsp;hallarda&nbsp;bonus&nbsp;mövcud&nbsp;olmayacaq.</p><p></p><p>⚡️&nbsp;Nə&nbsp;qədər&nbsp;aktiv&nbsp;oynayırsansa&nbsp;—&nbsp;böyük&nbsp;uduş&nbsp;şansın&nbsp;bir&nbsp;o&nbsp;qədər&nbsp;artır!</p><p>Oyunu&nbsp;maksimum&nbsp;gücə&nbsp;çatdırmaq&nbsp;fürsətini&nbsp;qaçırma!&nbsp;💸🔥</p>',
    relativeUrl: '',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/q2695tjtngsb.jpg',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/lae1cr6ypoqg.jpg',
    dateFrom: '2026-03-11 00:00:00',
    dateTo: '2035-03-18 23:59:00',
    weekDays: [true, true, true, true, true, true, true]
  },
  {
    id: 7,
    enabled: true,
    name: 'Приветственный бонус',
    position: 2,
    language: 'ru',
    gameType: 0,
    gameId: 0,
    makeBotLink: false,
    bannerText:
      'СТАРТУЙ С ЖИРНОГО БОНУСА В VULPIN CASINO! НОВАЯ БОНУСНАЯ СИСТЕМА — до 400% на первый депозит! Чем больше ты вносишь — тем круче твой старт: <br>Бонус-лестница:<p>от 50 000₽ — 400%</p><p>от 40 000₽ — 350%</p><p>от 30 000₽ — 300%</p><p>от 20 000₽ — 250%</p><p>от 10 000₽ — 200%</p><p>от 5 000₽ — 150%</p><p>от 1 000₽ — 100%</p><p>от 100₽ — 50%.&nbsp;&nbsp;</p><p><br></p><p>Без промокодов, без сложностей — просто сделай первый депозит и бонус активируется автоматически!&nbsp;</p><p>Вейджер на бонусы от 100% составляет х40. На 50%  и 100% составляет х5. Бонус активен 14 дней с момента регистрации. Во всех остальных случаях бонус будет недоступен.&nbsp;</p><p><br></p><p>Идеальное начало для новых игроков!Хочешь в 4 раза больше? Время — действовать!</p>',
    relativeUrl: 'firstdeposit',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/bonus_ru_pc.jpg',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/bonus 400 m.jpg',
    dateFrom: '2024-06-30 09:10:00',
    dateTo: '2030-06-30 09:10:00',
    weekDays: [true, true, true, true, true, true, true]
  },
  {
    id: 78,
    enabled: true,
    name: 'Xush kelibsiz bonus',
    position: 2,
    language: 'uz',
    gameType: 0,
    gameId: 0,
    makeBotLink: false,
    bannerText:
      '<p>VULPIN CASINO’da ZO‘R BONUS BILAN BOSHLANG!</p><p> YANGI BONUS TIZIMI — birinchi depozit uchun 400% gacha!</p><p>Qancha ko‘p mablag‘ kiritilsa — shuncha kuchli start bo‘ladi:</p><p> Bonus zinapoyasi:</p><p>▪️ 5 000 000 — 400%</p><p>▪️ 3 000 000 — 350%</p><p>▪️ 2 000 000 — 300%</p><p>▪️ 1 000 000 — 250%</p><p>▪️ 500 000 — 200%</p><p>▪️ 300 000 — 150%</p><p>▪️ 100 000  — 100%</p><p>▪️ 30 000  — 50%</p><p> Promokodsiz, qiyinchiliksiz — shunchaki birinchi depozitni qiling va bonus avtomatik tarzda faollashadi!</p><p>Bonuslar uchun veyjer 100% dan boshlab x40. 50% va 100% bonuslar uchun esa x5. Bonus ro‘yxatdan o‘tgan kundan boshlab 14 kun davomida faol bo‘ladi. Boshqa hollarda bonus mavjud bo‘lmaydi.</p><p> Yangi o‘yinchilar uchun ideal start!</p><p>To‘rt barobar ko‘proq olishni xohlaysizmi? Unda hoziroq harakat qiling!</p>',
    relativeUrl: 'bonus400',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/bonus_400_pc_uzs.jpg',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/bonus_uzs_m.jpg',
    dateFrom: '2024-12-15 10:06:00',
    dateTo: '2055-12-15 10:06:00',
    weekDays: [true, true, true, true, true, true, true]
  },
  {
    id: 201,
    enabled: true,
    name: '💖 Hesabı artırırsan? +15% geri al!',
    position: 3,
    language: 'az',
    gameType: 0,
    gameId: 0,
    makeBotLink: false,
    bannerText:
      '<p>💖&nbsp;Hesabı&nbsp;artırırsan?&nbsp;+15%&nbsp;geri&nbsp;al!</p><p>🎁&nbsp;Keşbek&nbsp;depozitdən&nbsp;sonra&nbsp;avtomatik&nbsp;verilir&nbsp;—&nbsp;əlavə&nbsp;hərəkət&nbsp;yoxdur</p><p>🎯&nbsp;Şərtlər&nbsp;sadədir:&nbsp;veycer&nbsp;x10,&nbsp;keşaut&nbsp;x3</p><p>💼&nbsp;Ağılla&nbsp;oyna&nbsp;—&nbsp;daha&nbsp;çox&nbsp;qazan!</p>',
    relativeUrl: '',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/vse97b6ytadl.jpg',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/frlamv32okc2.jpg',
    dateFrom: '2026-03-11 00:00:00',
    dateTo: '2035-03-18 23:59:00',
    weekDays: [true, true, true, true, true, true, true]
  },
  {
    id: 8,
    enabled: true,
    name: 'Кешбек 15%',
    position: 3,
    language: 'ru',
    gameType: 0,
    gameId: 0,
    makeBotLink: false,
    bannerText:
      'Получай кэшбэк 15% к каждому своему пополнению моментально!&nbsp;Пополнил 2000 рублей? 300 рублей кэшбэка зачислятся моментально! А вейджер супер низкий - всего х10!&nbsp;',
    relativeUrl: 'cashback_15',
    externalUrl: '',
    fileUrl: 'https://f.securebet.xyz/images/banners/cash_3_pc.jpg',
    mobileFileUrl: 'https://f.securebet.xyz/images/banners/cash_3_m.jpg',
    dateFrom: '2024-07-01 04:17:00',
    dateTo: '2030-07-01 04:17:00',
    weekDays: [true, true, true, true, true, true, true]
  }
];

export const mockUsers = {
  page: {
    no: 1,
    size: 100,
    count: 1
  },
  total: {
    userCount: 2
  },
  userList: [
    [
      679,
      'tg_Alidin13_8351439193_7',
      'gamer',
      'active',
      true,
      false,
      0,
      '8351439193',
      '',
      '79148960046'
    ],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', ''],
    [686, 'tg_BEZDEP1_8425906055_7', 'gamer', 'active', true, false, 0, '8425906055', '', '']
  ]
};

export const mockRight = {
  system: {
    // системные права
    sysChangeSelfPsword: false,
    sysViewReports: false,
    sysSiteAccess: false,
    sysInputInvoices: false,
    sysOutputInvoices: false,
    sysReportProfit: false,
    sysReportGroup: false,
    sysGameListEdit: false,
    sysViewOutputInvoices: false,
    sysCasinoSettings: false,
    sysGameAnalytics: false,
    sysCryptoGateAccess: false,
    sysInputGateRaw: false,
    sysOutputGateRaw: false,
    sysTrafficStatistics: false
  },
  group: {
    // права управления группами
    grpAccessSubgroups: false,
    grpChangeGroupOptions: false,
    grpEditGroup: false,
    grpRegisterGroup: false,
    grpDeleteGroup: false,
    grpChangeGroupLimit: false,
    grpLockGroup: false,
    grpViewFeedback: false,
    grpMoveGroup: false,
    grpJackpotActions: false,
    grpBonusControl: false,
    grpRefcodeControl: false,
    grpBannerControl: false
  },
  user: {
    // права управления пользователями
    usrBalanceReplenishment: true,
    usrPayout: true,
    usrRegisterUser: false,
    usrInstantPayouts: true,
    usrViewReferer: false,
    usrDeleteUsers: false,
    usrTransferUsers: false,
    usrSetRightsAccess: false,
    usrEditUser: false,
    usrChangeStatus: false,
    usrChangeUserPsword: false,
    usrViewFeedback: false,
    usrViewLog: false
  },
  view: {
    // права на просмотр информации
    viewOfflineUsers: false,
    viewGameLogins: false,
    viewManagers: false,
    viewPartners: false,
    viewAgents: false
  }
};

export const mockTemplate = {
  agent: {
    system: {
      sysChangeSelfPsword: true,
      sysViewReports: true,
      sysSiteAccess: true,
      sysInputInvoices: true,
      sysOutputInvoices: true
    },
    user: {
      // права управления пользователями
      usrBalanceReplenishment: true,
      usrPayout: true,
      usrRegisterUser: true
    }
  },
  manager: {
    system: {
      sysChangeSelfPsword: false,
      sysViewReports: false,
      sysSiteAccess: false,
      sysInputInvoices: false,
      sysOutputInvoices: true
    },
    user: {
      // права управления пользователями
      usrBalanceReplenishment: false,
      usrPayout: false,
      usrRegisterUser: true
    }
  },
  partner: {
    system: {
      sysChangeSelfPsword: true,
      sysViewReports: true,
      sysSiteAccess: false,
      sysInputInvoices: false,
      sysOutputInvoices: true
    },
    user: {
      // права управления пользователями
      usrBalanceReplenishment: true,
      usrPayout: true,
      usrRegisterUser: true
    }
  }
};

export const mockReportGamerList = [
  {
    playerId: 80,
    mail: 'player@mail.ru',
    dateRegister: '01-05-2026',
    dateFirstDep: '01-01-2020',
    sumFirst: 80,
    countRepDep: 3,
    sumRepeatDep: 160,
    averageDep: 80,
    sumBonus: 90,
    sumWagerBonus: 50,
    sumDep: 300,
    sumPayments: 500,
    sumBet: 2500,
    countSpin: 150,
    averageBet: 25,
    RTP: 2,
    GGR: 8,
    NGR: 2.25,
    currency: 'RUB',
    lastDate: '01-01-2025'
  },
  {
    playerId: 4,
    mail: 'player@mail.ru',
    dateRegister: '01-05-2026',
    dateFirstDep: '01-01-2020',
    lastDate: '01-01-2025',
    sumFirst: 80,
    countRepDep: 3,
    sumRepeatDep: 160,
    averageDep: 80,
    sumBonus: 90,
    sumWagerBonus: 50,
    sumDep: 300,
    sumPayments: 500,
    sumBet: 2500,
    countSpin: 150,
    averageBet: 25,
    RTP: 2,
    GGR: 8,
    NGR: 2.25,
    currency: 'RUB'
  }
];

export const mockBonusList = [
  {
    date: '2026-05-03',
    jackpot: { mini: 3, major: 10, grand: 50 },
    onRegister: [0, 0, 1, 1],
    onFirstDep: [15.2, 1, 1],
    caskBack: [2.2, 0, 1],
    promocode: [900, 10, 7],
    onRunBot: [0, 0, 0],
    total: 1
  },
  {
    date: '2026-05-02',
    jackpot: { mini: 2, major: 10, grand: 50 },
    onRegister: [0, 0, 1, 1],
    onFirstDep: [15.2, 1, 1],
    caskBack: [2.2, 0, 1],
    promocode: [5, 5, 3],
    onRunBot: [0, 0, 0],
    total: 5
  }
];

export const mockBonusTotal = {
  jackpot: { mini: 5, major: 20, grand: 100 },
  onRegister: [0, 0, 2, 2],
  onFirstDep: [30.4, 2, 2],
  caskBack: [4.4, 0, 2],
  promocode: [905, 15, 10],
  onRunBot: [0, 0, 0],
  total: 6
};

export const mockMailing = [
  {
    id: 1,
    status: 'inactive',
    title: 'Test A',
    sendAtDate: '2026-04-01 00:00:00',
    sendDateFrom: null,
    sendDateTo: null,
    sendAtTime: null,
    sendByDays: [false, false, false, false, false, false, false],
    userCount: 9,
    authorId: 2,
    authorLogin: 'Oleg'
  },
  {
    id: 2,
    status: 'inactive',
    title: 'Test B',
    sendAtDate: '2026-04-01 00:00:00',
    sendDateFrom: null,
    sendDateTo: null,
    sendAtTime: null,
    sendByDays: null,
    userCount: 4,
    authorId: 2,
    authorLogin: 'Oleg'
  },
  {
    id: 3,
    status: 'deleted',
    title: 'заголовок',
    sendAtDate: null,
    sendDateFrom: '2026-04-10 00:00:00',
    sendDateTo: '2026-04-12 00:00:00',
    sendAtTime: '15:00',
    sendByDays: [true, false, false, false, false, false, true],
    userCount: 1,
    authorId: 43,
    authorLogin: 'vadik'
  },
  {
    id: 4,
    status: 'inactive',
    title: 'test 2 однораз',
    sendAtDate: '2026-04-10 00:00:00',
    sendDateFrom: null,
    sendDateTo: null,
    sendAtTime: null,
    sendByDays: null,
    userCount: 3,
    authorId: 43,
    authorLogin: 'vadik'
  },
  {
    id: 5,
    status: 'inactive',
    title: 'Обновлённая рассылка',
    sendAtDate: null,
    sendDateFrom: '2026-04-14 00:00:00',
    sendDateTo: '2026-04-19 00:00:00',
    sendAtTime: '12:25',
    sendByDays: [true, true, false, true, true, false, false],
    userCount: 2,
    authorId: 43,
    authorLogin: 'vadik'
  },
  {
    id: 6,
    status: 'deleted',
    title: 'будущая рассылка',
    sendAtDate: '2026-05-09 00:00:00',
    sendDateFrom: null,
    sendDateTo: null,
    sendAtTime: null,
    sendByDays: null,
    userCount: 1,
    authorId: 43,
    authorLogin: 'vadik'
  },
  {
    id: 7,
    status: 'inactive',
    title: 'test2',
    sendAtDate: null,
    sendDateFrom: '2024-04-15 00:00:00',
    sendDateTo: '2024-04-17 00:00:00',
    sendAtTime: '04:00',
    sendByDays: [false, true, false, false, false, false, false],
    userCount: 3,
    authorId: 43,
    authorLogin: 'vadik'
  },
  {
    id: 8,
    status: 'active',
    title: 'Тестовая рассылка 233 А',
    sendAtDate: '2026-04-20 16:00:00',
    sendDateFrom: null,
    sendDateTo: null,
    sendAtTime: null,
    sendByDays: null,
    userCount: 1,
    authorId: 2,
    authorLogin: 'Oleg'
  }
];

export const mockMailingHistory = [
  {
    date: '2025-05-01 22:43:15',
    author: 'Vadim',
    group: 1,
    useSubGroup: false,
    countUser: 11,
    successSent: 11,
    notBotReg: 5,
    notMesUserLang: 4,
    errorSent: 0,
    botBlock: 2,
    userDelete: 2
  },
  {
    date: '2025-05-01 22:43:15',
    author: 'Vadim',
    group: 1,
    useSubGroup: false,
    countUser: 11,
    successSent: 11,
    notBotReg: 5,
    notMesUserLang: 4,
    errorSent: 0,
    botBlock: 2,
    userDelete: 3
  },
  {
    date: '2025-05-01 22:43:15',
    author: 'Vadim',
    group: 5,
    useSubGroup: true,
    countUser: 190,
    successSent: 91,
    notBotReg: 5,
    notMesUserLang: 4,
    errorSent: 99,
    botBlock: 5,
    userDelete: 6
  },
  {
    date: '2025-04-01 22:43:15',
    author: 'Vadim',
    group: 1,
    useSubGroup: true,
    countUser: 110,
    successSent: 101,
    notBotReg: 5,
    notMesUserLang: 4,
    errorSent: 9,
    botBlock: 10,
    userDelete: 8
  }
];

export const mockRefcodeData = [
  [0, 'h2i50azj', 'коммент 1', 5, 'Vulpin'],
  [1, '2026-04-02', 2, 0, 0, 0, 3000, 2, 3000, 0, 0],
  [2, 'h2i50azj', 2, 0, 0, 0, 3000, 2, 3000, 0, 0],
  [0, '94823517', 'New ref link', 117, 'Cash Empire Casino'],
  [1, '2026-04-24', 0, 0, 1, 0, 0, 0, 0, 0, 0],
  [2, '94823517', 0, 0, 1, 0, 0, 0, 0, 0, 0]
];

export const mockDepositsGraphic = {
  data: {
    total: {
      deposit: 4135,
      withdrawal: 0,
      profit: 4135,
      rtp: 613.34,
      ggr: -26298817,
      newGamers: 34
    },
    detail: {
      '2026/01': { deposit: [0, 0, 0, 36], withdrawal: 0 },
      '2026/02': { deposit: [0, 0, 0, 11], withdrawal: 0 },
      '2026/03': { deposit: [4135, 14, 1, 6], withdrawal: 0 },
      '2026/04': { deposit: [0, 0, 4, 2], withdrawal: 0 },
      '2026/05': { deposit: [0, 0, 0, 2], withdrawal: 0 }
    },

    ggr: {
      current: {
        from: '2026-05-01',
        to: '2026-05-15',
        total: -465959,
        lastPeriod: -35943,
        days: {
          '05/01': 0,
          '05/02': 0,
          '05/03': 0,
          '05/04': -490567,
          '05/05': 73947,
          '05/06': 0,
          '05/07': 0,
          '05/08': 0,
          '05/09': -49339,
          '05/10': 0,
          '05/11': 0,
          '05/12': 0,
          '05/13': 0,
          '05/14': 0,
          '05/15': 0
        }
      },
      previous: {
        from: '2026-04-16',
        to: '2026-04-30',
        total: 1300,
        lastPeriod: -100.19,
        days: {
          '04/16': 1300,
          '04/17': 0,
          '04/18': 0,
          '04/19': 0,
          '04/20': 0,
          '04/21': 0,
          '04/22': 0,
          '04/23': 0,
          '04/24': 0,
          '04/25': 0,
          '04/26': 0,
          '04/27': 0,
          '04/28': 0,
          '04/29': 0,
          '04/30': 0
        }
      }
    }
  }
};

export const mockOutputs = {
  options: {
    viewRaw: true
  },
  pageCount: 9,
  pageNo: 4,
  list: [
    [
      132,
      '80',
      10,
      1,
      9,
      'RUB',
      8,
      '2025-12-19 13:29:23',
      '2025-12-19 16:04:38',
      'phone',
      '',
      '',
      '',
      '',
      'hhlp',
      '',
      null,
      '+79800553535',
      'VTB',
      0.32,
      ['viewRaw']
    ]
  ],
  userList: {
    80: ['tg_dwellerIV_671251335_6', '9']
  },
  groupList: {
    9: ['BabloSlot.com', null]
  },
  casinoList: []
};

export const mockProvidersS = {
  '3oaks': {
    customName: '3oaks',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  EGT: {
    customName: 'EGT',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  'EGT Digital': {
    customName: 'EGT Digital',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  InBet: {
    customName: 'InBet',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  'PG Soft': {
    customName: 'PG Soft',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  "Play'nGO": {
    customName: "Play'nGO",
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  agt: {
    customName: 'agt',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  amatic: {
    customName: 'amatic',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  apollo: {
    customName: 'apollo',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  aristocrat: {
    customName: 'aristocrat',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  fox: {
    customName: 'fox',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  habanero: {
    customName: 'habanero',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  igrosoft: {
    customName: 'igrosoft',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  igt: {
    customName: 'igt',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  isoftbet: {
    customName: 'isoftbet',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  microgaming: {
    customName: 'microgaming',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  netent: {
    customName: 'netent',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  novomatic: {
    customName: 'novomatic',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  pragmatic: {
    customName: 'pragmatic',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  quickspin: {
    customName: 'quickspin',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  royal: {
    customName: 'royal',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  'scientific games': {
    customName: 'scientific games',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  spinomenal: {
    customName: 'spinomenal',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  wazdan: {
    customName: 'wazdan',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  },
  yggdrasil: {
    customName: 'yggdrasil',
    percent: 5,
    enabled: true,
    currencies: ['EUR']
  }
};
